import { render, staticRenderFns } from "./PondDetail.vue?vue&type=template&id=6d3b5a6e&"
import script from "./PondDetail.vue?vue&type=script&lang=js&"
export * from "./PondDetail.vue?vue&type=script&lang=js&"
import style0 from "./PondDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports